<template>
    <div class="content-wrapper">
        <div class="d-none">
            <app-breadcrumb :page-title="$t('onboarding_site')" :directory="$t('datatables')" :icon="'grid'" />
        </div>


        <app-timeline-filter
                v-if="!this.impersonate"
                :filter-option="filterOptions"
                :timeline-candidates="timelineCandidates"
                :timeline-states="timelineStates"
                @get-value="store"
            />



        <app-onboarding-site-editor
                :selectedUrl="selectedSiteUrl"
                :selectedId="selectedId"
                :uploadedImage="uploadedImage"
                :timeline-states="timelineStates"
                @getImageAction="getSelectedImagesAction">
        </app-onboarding-site-editor>

        <form-editor-files
                :selectedId="selectedId"
                :selectedAction="selectedAction"
                @getUploadedImage="getUploadedImages">
        </form-editor-files>

    </div>
</template>
<script>
    import {FormMixin} from '../../../../../../core/mixins/form/FormMixin.js';
    import * as actions from "../../../../../Config/ApiUrl";

    export default {
        name: "FormInputs",
        mixins: [FormMixin],
        data() {
            return {
                selectedId: 1,
                impersonate: false,
                selectedAction: '',
                timelineCandidates: [],
                timelineStates: [],
                filterOptions: [
                    {id: '7', value: 'Před nástupem'},
                    {id: '8', value: 'První den'},
                    {id: '9', value: 'Zkušební doba'},
                    {id: '10', value: 'Zaměstnání'},
                    {id: '11', value: 'Povýšení'},
                    {id: '12', value: 'Mateřská'},
                    {id: '13', value: 'Offboarding'},
                ],
                candidateOptions: [],
                allFilterValues: {
                    "filter_with_status": 3,
                    "filter_with_timeline_state": 7,
                },
                uploadedImage: {},
                options: {
                    currentMainTab: 2,
                    mainTabs: [
                        {page: actions.DATATABLE_ONBOARDING_URL, pageName: this.$t('people')},
                        {page: actions.DATATABLE_ONBOARDING_CHECKLIST_URL, pageName: this.$t('my_tasks'), className:'guide-step-onboarding-2'},
                        {page: '', pageName: this.$t('onboarding_site'), condition: true, className: 'guide-step-onboarding-1'},
                        {page: '../onboarding/document/', pageName: this.$t('documents'),className:'guide-step-checklist-4'},
                    ],
                },



            }
        },
        created() {
            this.selectedId = parseInt(this.getSiteId());
            this.selectedSiteUrl = actions.SITE_ONBOARDING_DATA+'/'+this.selectedId;
            this.getOnboardingSites();
            this.getTimelineStateNames();

            if(location.href.indexOf('impersonate=') != -1){
                this.impersonate = true;
            }

        },
        mounted() {
            this.getCandidateNumbers();

        },
        methods: {
            getUrlParameter(name, url) {
                if (!url) url = location.href;
                name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
                var regexS = "[\\?&]"+name+"=([^&#]*)";
                var regex = new RegExp( regexS );
                var results = regex.exec( url );
                return results == null ? null : results[1];
            },
            getSelectedImagesAction(place) {
                console.log('click! '+place);
                this.selectedAction = place;
            },
            getUploadedImages(response) {
                console.log('uploaded!'+response);
                this.uploadedImage = response;
                this.selectedAction = ''; // Hide modal
            },
            getSiteId() {
                var url = window.location.href;
                return url.substring(url.lastIndexOf('/') + 1);
            },


            /**
             * Onboarding button (based on advanced filter values)
             * */

            store(v) {
                this.filterValues[v.key] = v.value;
                this.$emit('get-values', this.filterValues);

                if(v.key == 'filter_with_job'){
                    this.filterJob = v.value;
                }

                if(v.key == 'filter_with_timeline_state'){
                    this.filterTimelineState = v.value;
                }

            },


            /**
             * Timeline (based on basic and advanced filters values)
             * */

            getCandidateNumbers() {
                let totalsQuery = '';
                let allFilters = this.allFilterValues;

                if(allFilters){
                    let i = 0;

                    Object.keys(allFilters).forEach(function(key, index) {
                        i++;

                        if(i == 1 && key != 'filter_with_timeline_state' && allFilters[key]){
                            totalsQuery += key+'='+allFilters[key]

                        } else if (key != 'filter_with_timeline_state' && allFilters[key]) {
                            totalsQuery += '&'+key+'='+allFilters[key]

                        }
                    });

                }

                if(this.searchValue){
                    if(allFilters){
                        totalsQuery += '&search='+this.searchValue;
                    } else {
                        totalsQuery += 'search='+this.searchValue;
                    }

                }

                let job = parseInt(this.getUrlParameter('job', location.href));
                this.axiosGet(actions.TIMELINE_DATA+'?'+totalsQuery+'&filter_with_job='+job).then(response => {
                    if(response.data.length){
                        this.timelineCandidates = response.data.data;
                    } else {
                        this.timelineCandidates = response.data.data;
                    }

                });



            },
            getTimelineStateNames() {

                this.axiosGet(actions.TIMELINE_STATES_DATA+'?status=3').then(response => {
                    if(response.data.length){
                        this.timelineStates = response.data;
                    } else {
                        this.timelineStates = response.data;
                    }



                });

            },
            getOnboardingSites() {

                let job = parseInt(this.getUrlParameter('job', location.href));
                this.axiosGet('admin/app/onboardingsite?job='+job).then(response => {

                    let timelineStates = response.data;
                    for (var i in timelineStates) {
                        //this.filterOptions[i].site = timelineStates[i].id;
                       // this.filterOptions[i].job = job;
                    }


                });

            },

        },
    }
</script>
